import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { LookalikeButtonIconProps as Props } from './types';

export const LookalikeButtonIcon = memo(({ className, selected }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('LookalikeButtonIcon', className)}
      sxx={SX.root}
      name={selected ? 'minus' : 'plus'}
      color={selected ? 'primary' : 'inherit'}
      size={20}
    />
  );
});

LookalikeButtonIcon.displayName = 'LookalikeButtonIcon';
